import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { TIDS } from "@/constants/testIds";
import PasswordInput from "@/components/PasswordInput";

export default function Signup() {
  const [form, setForm] = useState({ username: "", email: "", password: "", dob: "", age_attested: false });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { signup } = useAuth();
  const nav = useNavigate();

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await signup(form);
      nav("/dashboard");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Signup failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-12">
      <form onSubmit={submit} className="w-full max-w-md sc-card p-8">
        <div className="sc-label text-[#00E5FF]">Join the cast</div>
        <h2 className="sc-heading text-3xl font-black mb-6 mt-1">Create your channel</h2>
        <label htmlFor="signup-username" className="sc-label block mb-2">Username</label>
        <input data-testid={TIDS.signupUsername} id="signup-username" name="username" autoComplete="username" value={form.username} onChange={upd("username")} className="sc-input mb-4" required minLength={3} />
        <label htmlFor="signup-email" className="sc-label block mb-2">Email</label>
        <input data-testid={TIDS.signupEmail} id="signup-email" name="email" type="email" autoComplete="email" value={form.email} onChange={upd("email")} className="sc-input mb-4" required />
        <label htmlFor="signup-password" className="sc-label block mb-2">Password</label>
        <PasswordInput id="signup-password" name="new-password" autoComplete="new-password" data-testid={TIDS.signupPassword} value={form.password} onChange={upd("password")} className="mb-1" required minLength={8} />
        <div className="text-[10px] text-zinc-500 mb-4" data-testid="signup-password-hint">
          Min 8 characters · include at least one letter and one number
        </div>
        <label htmlFor="signup-dob" className="sc-label block mb-2">Date of Birth (must be 18+)</label>
        <input data-testid={TIDS.signupDob} id="signup-dob" name="bday" type="date" autoComplete="bday" value={form.dob} onChange={upd("dob")} className="sc-input mb-4" required />
        <label className="flex items-start gap-2 text-xs text-zinc-300 mb-4 cursor-pointer">
          <input data-testid={TIDS.signupAttest} id="signup-age-attest" name="age_attested" type="checkbox" checked={form.age_attested} onChange={upd("age_attested")} className="mt-0.5 accent-[#FF3366]" />
          <span>I confirm I am 18+ and accept the MystiCast Terms.</span>
        </label>
        {err && <div className="text-[#FF3366] text-xs mb-3">{err}</div>}
        <button data-testid={TIDS.signupSubmit} disabled={busy} className="sc-btn w-full">{busy ? "Creating..." : "Create account"}</button>
        <div className="text-xs text-zinc-400 mt-4 text-center">
          Already have one? <Link to="/login" className="text-[#00E5FF] hover:underline">Log in</Link>
        </div>
      </form>
    </div>
  );
}
